var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.3092C11.8667 11.3092 11.3 11.5502 10.8667 11.9277L4.925 8.59438C4.96667 8.40964 5 8.2249 5 8.03213C5 7.83936 4.96667 7.65462 4.925 7.46988L10.8 4.16867C11.25 4.57028 11.8417 4.81928 12.5 4.81928C13.8833 4.81928 15 3.74297 15 2.40964C15 1.07631 13.8833 0 12.5 0C11.1167 0 10 1.07631 10 2.40964C10 2.60241 10.0333 2.78715 10.075 2.97189L4.2 6.27309C3.75 5.87149 3.15833 5.62249 2.5 5.62249C1.11667 5.62249 0 6.69879 0 8.03213C0 9.36546 1.11667 10.4418 2.5 10.4418C3.15833 10.4418 3.75 10.1928 4.2 9.79116L10.1333 13.1325C10.0917 13.3012 10.0667 13.4779 10.0667 13.6546C10.0667 14.9478 11.1583 16 12.5 16C13.8417 16 14.9333 14.9478 14.9333 13.6546C14.9333 12.3614 13.8417 11.3092 12.5 11.3092Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.86b5dc7f1bc0842d166664fd70d659b0.svg";
export { ForwardRef as ReactComponent };